import React from 'react';
import './AutoPlay.css';

const AutoPlay = (props) => {
    if (!props.visible) return null;

    return (
        <button
            className="b-button b-auto-play"
            onClick={props.toggleAutoplay}
        >
            <i className="fas fa-play"></i>
        </button>
    );
};

export default AutoPlay;
